import Splide from '@splidejs/splide';
export const init = () => {
    initCarousel();
    const observer = new MutationObserver(() => {
        initCarousel();
    })
    observer.observe(document.querySelector('.main'), {
        childList: true
    })
}
function initCarousel() {
    if (document.querySelector('.carousel_type-10')) {
        const carousel10 = document.querySelectorAll('.carousel_type-10');
        carousel10.forEach((item) => {
            const splideCarousel10 = new Splide(item, {
                arrows: false,
                pagination: true,
                perPage: 5,
                perMove: 5,
                gap: 32,
                classes: {
                    pagination: 'splide__pagination g-pagination__type-1',
                },
                drag: false,
                breakpoints: {
                    1210: {
                        perPage: 4,
                        perMove: 4
                    },
                    1055: {
                        perPage: 3,
                        perMove: 3,
                        drag: true
                    },
                    755: {
                        perPage: 2,
                        perMove: 2
                    },
                    510: {
                        perPage: 1,
                        perMove: 1
                    }
                } 
            });
            splideCarousel10.mount();
            const arrowLeft = item.querySelector('.button--prev');
            const arrowRight = item.querySelector('.button--next');
            const { Controller } = splideCarousel10.Components;
            if (Controller.getPrev() === Controller.getNext()) {
                arrowLeft.parentElement.classList.add('hidden');
            }
            splideCarousel10.on('move', (newIndex) => {
                switch (newIndex) { 
                    case 0: 
                        arrowLeft.classList.add('disabled'); 
                        arrowRight.classList.remove('disabled');
                        break;
                    case Controller.getEnd():
                        arrowRight.classList.add('disabled');  
                        arrowLeft.classList.remove('disabled');
                        break;
                    default:
                        arrowLeft.classList.remove('disabled');
                        arrowRight.classList.remove('disabled');  
                } 
            });
            arrowLeft.addEventListener('click', () => splideCarousel10.go('<'));
            arrowRight.addEventListener('click', () => splideCarousel10.go('>'));
        });
    }
}